import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MIDDLE_WARE_BASE_URL_v1, CALL_PPOR_API } from "../../../../utils/CONSTANTS";
import axios from "../../../../utils/axios";
const initialState = {
    status : '',
    state : '',
    inboxData : [],
};
export const inboxEmail = createAsyncThunk("post/inboxEmail", async (data: any) => {
  console.log("inboxEmail REQUEST ->", JSON.stringify(data?.input)); // DEBUG: shows the userOracleId being sent
  console.trace("inboxEmail dispatched from ->");                    // DEBUG: call stack = which component fired it
  const response = await axios.postStringRequest(MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API() ,  data.input); // added await
  return response;
});
export const inboxEmailSlice = createSlice({
    name : 'inboxEmail',
    initialState,
    reducers : {},
    extraReducers : (builder : any) =>
       builder
       .addCase(inboxEmail.pending, (state : any) =>
       {
            state.state = 'pending';
       })
       .addCase(inboxEmail.fulfilled, (state : any,action : any) =>
       {
           // GUARD: bail out safely if response is missing (prod crash fix)
           const raw = action?.payload?.data?.response;
           if (raw == null) {
               console.warn("inboxEmail: missing data.response ->", action?.payload);
               state.status = action?.payload?.status ?? '';   // e.g. "Failed"
               state.state = 'failed';                          // reflect real outcome, not fulfilled
               state.inboxData = [];
               return;
           }
           state.state = 'fulfilled';
           let json = typeof raw === 'string' ? raw : JSON.stringify(raw);
           json = json.replace(/\\"/gi, '"').replace('"{', "{").replace('}"','}');
           let parsed: any = null;
           try {
               parsed = JSON.parse(json);
           } catch {
               state.status = '';
               state.state = 'failed';   // malformed JSON = failure, not success
               state.inboxData = [];
               return;
           }
           const response = parsed?.response;
           if (!response) {
               state.status = '';
               state.state = 'failed';
               state.inboxData = [];
               return;
           }
           state.status = response?.status;
           let jsonArray = Object.keys(response).map((key) => response[key]);
           if (jsonArray.length === 3){
                if (Array.isArray(response?.emailList)) {
                    state.inboxData = response?.emailList
                }
                else{
                    state.inboxData = [response?.emailList]
                }
           }
           else{
           }
       })
       .addCase(inboxEmail.rejected, (state : any) =>
       {
            state.state = 'failed';
       })
});
export const selectInboxEmail = ((state : any) => state.inboxEmail || {});
export default inboxEmailSlice.reducer;
